import { render, staticRenderFns } from "./ToolsSideMenu.vue?vue&type=template&id=03408cf0&scoped=true&"
import script from "./ToolsSideMenu.vue?vue&type=script&lang=js&"
export * from "./ToolsSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./ToolsSideMenu.vue?vue&type=style&index=0&id=03408cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03408cf0",
  null
  
)

export default component.exports